import { render, staticRenderFns } from "./Webrtc.vue?vue&type=template&id=3062c5b0"
import script from "./Webrtc.vue?vue&type=script&lang=js"
export * from "./Webrtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports